import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Row, Col, Table, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from "reactstrap"
import { adminPrefix } from "configs/routePrefix"
import { toast } from "react-toastify"
import { SuccessOk } from "configs/statusCode"
import compoundImg from "assets/images/bg.png"
import LeadService from "services/Admin/LeadService"
import { ImagePreview, PreviewContainer } from "components/Common/file-upload/file-upload.styles";
import AppoinmentService from "services/Admin/AppoinmentService"
import FeedbackModal from "../FeedbackModal"
import moment from "moment"
import { useSelector } from "react-redux"
import Pagination from "../../Ratting/Pagination"

const ViewDealPage = (props) => {
    const AuthData = useSelector(state => state.Auth)
    const [feedbackModal, setFeedbackModal] = useState(false)
    const appoinmentService = new AppoinmentService()
    const [appoinment, setAppoinment] = useState(null)
    const [shouldUpdateDate, setShouldUpdateDate] = useState(0)
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownStatus, setDropdownStatus] = useState(false);
    const [dealsData, setDealsData] = useState([])
    const id = props.match.params.id
    const toggle = () => setDropdownOpen(prevState => !prevState);
    const toggleStausDropdown = () => setDropdownStatus(prevState => !prevState);
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const [feedback, setFeedback] = useState([]);

    const onChangeFeedback = (listData) => {
        setFeedback([...listData])
    }
    const onChangeDeals= (listData) => {
        setDealsData([...listData])
    }
    const getAppoinmentData = () => {
        appoinmentService.find(id).then(response => {
            if (response && response.status === SuccessOk) {
                setAppoinment(response.data)
            }
        })
    }

    useEffect(() => {
        getAppoinmentData()
    }, [shouldUpdateDate])

    const custimizeQueries = (query) => {
        const custimizedQuery = []
        for (let key in query) {
            if (query[key] !== "" && key !== "query" && key !== "id" && key !== "date") {
                custimizedQuery.push(`${key} : ${query[key]}`)
            }
        }
        return custimizedQuery
    }
    const getBackGround = (status) => {
        return status === "Contacted" ? "#007afd"
            : status === "Uncontacted" ? "#17a2b8"
                : status === "Lost" ? "#bf0b0b"
                    : status === "Won" ? "#34c38f"
                        : status === "Open" ? "#50a5f1"
                            : "#74788d"

    }

    const changeStateHandler = (status) => {
        const data = { status }
        appoinmentService.toggleStatus(appoinment.id, data).then(res => {
            if (res && res.status === SuccessOk) {
                setAppoinment({ ...appoinment, status })
                toast.success("Status changed successfully")
            }
        })
    }
    return (
        <React.Fragment>
            <div className='page-content view-appoinment-page'>
                <MetaTags>
                    <title>View Appoitnment</title>
                </MetaTags>
                <Container fluid>
                    <Row>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col md={6}>
                                        <h4>
                                            <button className="p-0 m-0 border-0"
                                                onClick={() => {
                                                    props.history.push(`${adminPrefix}/appoinments`)
                                                }}>
                                                <i className="fa fa-arrow-left text-success me-2"></i>
                                            </button>
                                            View Appointment Details
                                           <span className="mx-2">
                                                <Dropdown color="light" isOpen={dropdownStatus} toggle={toggleStausDropdown}>
                                                    <DropdownToggle >
                                                        <Badge
                                                            className="font-size-14 m-0 text-white p-2"
                                                            style={{ background: appoinment ?.status === "Canceled" ? "#74788d" : appoinment ?.status === "Done" ? "#34e38f" : "#50a5f1"  }}
                                                        >
                                                            {appoinment ?.status} <i className="fas fa-chevron-down text-white"></i>
                                                        </Badge>
                                                    </DropdownToggle>
                                                    {isExist("appointment.edit") ? <DropdownMenu>
                                                        {appoinment ?.status && ["Upcoming", "Done", "Canceled"].filter(item => item !== appoinment ?.status).map((status, index) => {
                                                            return (
                                                                <DropdownItem key={index} onClick={() => changeStateHandler(status)}>{status}</DropdownItem>
                                                            )
                                                        })}
                                                    </DropdownMenu> : null}
                                                </Dropdown>
                                            </span>
                                        </h4>
                                    </Col>
                                    <Col md={6} className="d-flex flex-md-row-reverse">
                                    {isExist("appointment.edit") || isExist("appointment.feedback") ?   <Dropdown className="dropdownWidth removebtnhover" color="light" isOpen={dropdownOpen} toggle={toggle}>
                                            <DropdownToggle caret>
                                                <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                {isExist("appointment.edit") ?
                                                    <DropdownItem
                                                        onClick={() => props.history.push(`${adminPrefix}/appoinments/edit-appoinment/${appoinment.id}`)}
                                                    >Edit</DropdownItem> : null}
                                                {isExist("appointment.feedback") ?
                                                    <DropdownItem onClick={() => {
                                                        if(!appoinment?.owner?.id){
                                                            toast.error("Please assign Sales Rep ")
                                                        }else{
                                                            setFeedbackModal(!feedbackModal)
                                                        }
                                                    }}>Add Feedback</DropdownItem>  :null}
                                            </DropdownMenu>
                                        </Dropdown> :null}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row className="mx-2">
                        <Col md={6} >
                            <Row>
                                <Card className="mt-2 px-0  ">
                                    <CardBody className="pb-0">
                                        <Row className="mb-4  mx-1">
                                            <Row className="mb-0 px-0">
                                                <p className="fw-bold font-size-16 mb-1">Basic info</p>
                                                <p className="font-size-14 text-muted mb-0">Here all the information related to Deal</p>
                                            </Row>
                                            <hr className="mt-1 mb-2" />
                                            <Row className="mb-0">
                                                <Col md={4} className="mb-2">
                                                    <Row className="font-size-14 text-muted mb-0">Name</Row>
                                                    <Row className="fw-bold">{appoinment ?.title}</Row>
                                                </Col>
                                                <Col md={8}>
                                                    <Row className="font-size-14 text-muted mb-0">Type</Row>
                                                    <Row className="fw-bold">{appoinment ?.type}</Row>
                                                </Col>
                                                {appoinment ?.type === "visit" ? <Col md={4}>
                                                    <Row className="font-size-14 text-muted mb-0">Location</Row>
                                                    <Row className="fw-bold">{appoinment ?.location}</Row>
                                                </Col> : null}
                                                <Col md={appoinment ?.type === "visit" ? 8 : 12}>
                                                    <Row className="font-size-14 text-muted mb-0">Date of creation</Row>
                                                    <Row className="fw-bold">{appoinment ?.date ? moment(appoinment ?.date).format("DD MMMM YYYY") : ""} {appoinment ?.time}</Row>
                                                </Col>
                                            </Row>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Row>
                        </Col>
                        <Col md={6} style={{ paddingRight: 0 }} >
                            <Row className="px-0 mx-1 ">
                                <Card className="mt-2 px-0  mr-2 ">
                                    <CardBody className="pb-0">
                                        <Row className="mb-4  mx-1">
                                            <Row className="mb-0 px-0">
                                                <p className="fw-bold font-size-16 mb-1">Lead informations</p>
                                                <p className="font-size-14 text-muted mb-0">All the informations related to the lead</p>
                                            </Row>
                                            <hr className="mt-1 mb-2" />
                                            <Row className="mb-0">
                                                <Col md={4} className="mb-2">
                                                    <Row className="font-size-14 text-muted mb-0">Client Name</Row>
                                                    <Row className="fw-bold">{appoinment ?.client ?.name}</Row>
                                                </Col>
                                                <Col md={8}>
                                                    <Row className="font-size-14 text-muted mb-0">Phone</Row>
                                                    <Row className="fw-bold">{appoinment ?.client ?.phone}</Row>
                                                </Col>
                                                <Col md={12}>
                                                    <Row className="font-size-14 text-muted mb-0">Email</Row>
                                                    <Row className="fw-bold">{appoinment ?.client ?.email}</Row>
                                                </Col>
                                            </Row>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="px-0 mx-2 ">
                        <Card className="mt-2 px-0  mr-2 ">
                            <CardBody className="pb-0">
                                <Row className="mb-4  mx-1">
                                    <Row className="mb-0 px-0">
                                        <p className="fw-bold font-size-16 mb-1">Deal Unit</p>
                                        <p className="font-size-14 text-muted mb-0">All the informations related to the deal</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                                 <Row >
                                                    <Row>
                                                        <Col md={2} className="my-2 ">
                                                            <Row className="font-size-14 text-muted">Unit Code</Row>
                                                            <Row className="fw-bold">{!!appoinment?.unit?.name?.en ? appoinment?.unit?.name?.en : appoinment?.resale?.name?.en}</Row>
                                                        </Col>
                                                        <Col md={2} className="my-2 ">
                                                            <Row className="font-size-14 text-muted">Location</Row>
                                                            <Row className="fw-bold">{!!appoinment?.unit?.area?.name?.en ? appoinment?.unit?.area?.name?.en : appoinment?.resale?.area?.name}</Row>
                                                        </Col>
                                                        {appoinment?.unit?.compound?.name && <Col md={2} className="my-2 ">
                                                            <Row className="font-size-14 text-muted">Compound Name</Row>
                                                            <Row className="fw-bold">{appoinment ?.unit ?.compound ?.name ?.en}</Row>
                                                        </Col>}
                                                        {!!appoinment?.resale?.compound?.name?.en && <Col md={2} className="my-2 ">
                                                            <Row className="font-size-14 text-muted">Compound Name</Row>
                                                            <Row className="fw-bold">{appoinment ?.resale?.compound?.name?.en}</Row>
                                                        </Col>}
                                                        <Col md={2} className="my-2 ">
                                                            <Row className="font-size-14 text-muted">Size</Row>
                                                            <Row className="fw-bold">{!!appoinment?.unit?.size ? parseInt(appoinment ?.unit ?.size).toFixed(0) : parseInt(appoinment?.resale?.total_built_up_area).toFixed(0)} m</Row>
                                                        </Col>
                                                        <Col md={2} className="my-2 ">
                                                            <Row className="font-size-14 text-muted">Price</Row>
                                                            <Row className="fw-bold">{!!appoinment?.unit?.price ? toCurrency(appoinment?.unit?.price) : toCurrency(appoinment?.resale?.payment_plan?.total_price)}</Row>
                                                        </Col>
                                                        <Col md={2} className="my-2 ">
                                                            <Row className="font-size-14 text-muted">Installments</Row>
                                                            <Row className="fw-bold">{appoinment ?.installment ? appoinment ?.installment : " Cash only"}</Row>
                                                        </Col>
                                                        <Col md={2} className="my-2 ">
                                                            <Row className="font-size-14 text-muted">Unit Type</Row>
                                                            <Row className="fw-bold">{!!appoinment ?.unit ?.unit_type ?.name ?.en ? appoinment ?.unit ?.unit_type ?.name ?.en : appoinment?.resale?.resale_type?.name?.en}</Row>
                                                        </Col>
                                                    </Row>
                                                    <Row  >
                                                        {appoinment ?.unit ?.images ?.length > 0 &&
                                                                 <Row className="py-2 px-1">
                                                                    {appoinment ?.unit ?.images.map((file, index) => {
                                                                        if (file ?.path) {
                                                                            return (
                                                                                <PreviewContainer key={index}>
                                                                                    <ImagePreview
                                                                                        src={file.path}
                                                                                        alt={`file preview ${index}`}
                                                                                    />
                                                                                </PreviewContainer>
                                                                            )
                                                                        }
                                                                    })}
                                                            </Row>}
                                                     </Row>
                                                </Row>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row className="px-0 mx-2 ">
                        <Card className="mt-2 px-0  mr-2 ">
                            <CardBody className="pb-0">
                                <Row className="mb-4  mx-1">
                                    <Row className="mb-0 px-0">
                                        <p className="fw-bold font-size-16 mb-1">Appoinment Description</p>
                                        <p className="font-size-14 text-muted mb-0">All the information related to the Appointment</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <Row className="mb-0 fw-bold des-break"  >
                                        {appoinment ?.description ?.split("\n").map((item) => {
                                            return (
                                                <>
                                                    {item}
                                                    <br />
                                                </>
                                            )
                                        })}

                                    </Row>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row className="m-2">
                        <Col>
                            <Card className="w-100  px-0">
                                <CardBody className="pb-0">
                                    <div className="mb-4">
                                        <Row className="mb-0">
                                            <Col>
                                                <h5 className="fw-bold">Deals</h5>
                                                <p>All the information related the  deals</p>
                                            </Col>
                                        </Row>
                                        <hr className="mt-1 mb-2" />
                                        <div className="table-view-lead">
                                            <Table>
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-14">Unit</th>
                                                        <th className="font-size-14">Location</th>
                                                        <th className="font-size-14">Compound</th>
                                                        <th className="font-size-14">Property Type</th>
                                                        <th className="font-size-14">Size</th>
                                                        <th className="font-size-14">Budget</th>
                                                        <th className="font-size-14">Creation Date</th>
                                                        <th className="font-size-14">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dealsData ?.map((deal, index) => {
                                                        return (
                                                            <tr key={index}>
                                                            <th className="font-size-14">{!!deal?.unit ?.id ? deal?.unit ?.id : deal?.resale ?.id}</th>
                                                            <th className="font-size-14">{!!deal ?.unit?.area ?.name ?.en ? deal ?.unit?.area ?.name ?.en : deal?.resale?.area?.name}</th>
                                                            <th className="font-size-14">{!!deal?.unit?.compound?.name?.en ? deal?.unit?.compound?.name?.en : !!deal?.resale?.compound?.name?.en ? deal?.resale?.compound?.name?.en : '-'}</th>
                                                            <th className="font-size-14">{!!deal ?.unit?.unit_type ?.name ?.en ? deal ?.unit?.unit_type ?.name ?.en : deal ?.resale?.resale_type ?.name ?.en}</th>
                                                            <th className="font-size-14">{!!deal ?.unit ?.size ? deal ?.unit ?.size : deal ?.resale ?.total_built_up_area} m</th>

                                                            <th className="font-size-14">{toCurrency(!!deal ?.unit?.price ? deal ?.unit?.price : deal?.resale?.payment_plan?.total_price)}</th>
                                                            <th className="font-size-14">{deal ?.created_at}</th>

                                                            <th className="font-size-14 ">
                                                                <Badge
                                                                    className="bgBadge-admin font-size-14 m-0 text-white"
                                                                    style={{ background: getDealBackGround(deal ?.status) }}>{deal ?.status}
                                                                </Badge>
                                                            </th>
                                                        </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                            {appoinment ?.deals ?.length ?
                                                <Row className="d-flex justify-content-end">
                                                    <Pagination items={appoinment ?.deals  } onChangePage={onChangeDeals} />
                                                </Row> : null
                                            }
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="px-0 mx-2 ">
                        <Card className="mt-2 px-0  mr-2 ">
                            <CardBody className="pb-0">
                                <Row className="mb-4  mx-1">
                                    <Row className="mb-0 px-0">
                                        <Col>
                                            <p className="fw-bold font-size-16 mb-1">Feddback log</p>
                                            <p className="font-size-14 text-muted mb-0">Here all the information related to  lead interest</p>
                                        </Col>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <Row className="mb-0 fw-bold">
                                        <div className="table-view-lead">
                                            <Table>
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-14 ">Title</th>
                                                        <th className="font-size-14 ">Feedback Creator</th>
                                                        <th className="font-size-14 ">Activity Type</th>
                                                        <th className="font-size-14 ">Description</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {feedback ?.map((item, index) => {
                                                        return (
                                                            <tr key={index}  >
                                                                <th className="font-size-14 ">{item.title}</th>
                                                                <th className="font-size-14 ">{item.admin}</th>
                                                                <th className="font-size-14 ">{item.activity}</th>
                                                                <th className="font-size-14 ">
                                                                    {item ?.description ?.split("\n").map((item) => {
                                                                        return (
                                                                            <>
                                                                                {item}
                                                                                <br />
                                                                            </>
                                                                        )
                                                                    })}
                                                                </th>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                            {appoinment ?.feedbacks ?.length ?
                                                <Row className="d-flex justify-content-end">
                                                    <Pagination items={appoinment ?.feedbacks } onChangePage={onChangeFeedback} />
                                                </Row> : null
                                            }
                                        </div>
                                    </Row>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                    {feedbackModal ? <FeedbackModal
                        modal={feedbackModal}
                        id={appoinment.id}
                        type="details"
                        setShouldUpdateDate={setShouldUpdateDate}
                        toggle={() => setFeedbackModal(!feedbackModal)} /> : null}
                </Container>
            </div>
        </React.Fragment>
    )
}
const getDealBackGround = (status) => {
    return status === "Contacted" ? "#34e38f"
        : status === "Uncontacted" ? "#74788d"
            : status === "Lost" ? "#bf060b"
                : status === "Won" ? "green"
                    : status === "Open" ? "#50a5f1"
                        : "#f1874c"
}
const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(number);
}
export default ViewDealPage
